enum PayablesNewPayableSelectRecipientActionType {
    PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_REQUEST_DATA = "PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_REQUEST_DATA",
    PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_LOAD_DATA = "PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_LOAD_DATA",
    PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_FETCH_MORE_DATA = "PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_FETCH_MORE_DATA",
    PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_APPEND_MORE_DATA = "PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_APPEND_MORE_DATA",
    PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_DISPLAY_ERROR = "PAYABLES_NEW_PAYABLE_SELECT_RECIPIENT_DISPLAY_ERROR",
}

export default PayablesNewPayableSelectRecipientActionType;